import "./App.css";
import { useEffect, useRef, useState } from "react";
import paragraph from "./data";
import useInterval from "./useInterval";
import { BiTimer } from "react-icons/bi";
import { FaRandom } from "react-icons/fa";
import Button from "./Components/Commons/Button";

function App() {
  const [paraState, setParaState] = useState(
    new Array(paragraph.length).fill("notInitialized")
  );
  const [typingSpeed, setTypingSpeed] = useState(0);
  const [gameState, setGameState] = useState("notInitialized");
  const timerRef = useRef(null);
  const totalMSToRun = 20000;
  const [timeRemaining, setTimeRemaining] = useState(totalMSToRun);
  const [userInput, setUserInput] = useState("");
  const [mismatch, setMismatch] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [curentTypingIndex, setCurrentTypingIndex] = useState(0);
  const numOfWords = paragraph.toString().split(" ").length;
  const totalCharacters = paragraph.length;
  const averageWordLength = totalCharacters / numOfWords;

  const completeTest = () => {
    setGameState(() => "completed");
  };

  const restartGame = () => {};

  useInterval(
    () => {
      // Changing time remaining, reducing the length by the the time elapsed which is 1000MS
      setTimeRemaining((prev) => prev - 1000);
      setTimeElapsed((p) => p + 1000);
      console.log("set interval!");
      const completedChars = paraState.filter(
        (item) => item === "completed"
      ).length;
      const completedWords = completedChars / averageWordLength;
      const speed =
        Math.round(
          ((completedWords * 120) / ((timeElapsed + 1000) / 1000).toFixed(1)) *
            100
        ) / 100;
      console.log("time elapsed in sec: ", timeElapsed / 1000);
      setTypingSpeed(speed);
    },
    gameState === "notInitialized" || gameState === "completed" ? null : 1000
  );

  const runTimeOut = () => {
    setGameState(() => "inProgress");
    timerRef.current = setTimeout(() => {
      setTimeRemaining(() => 0);
      setGameState(() => "completed");
    }, totalMSToRun);
  };

  useEffect(() => {
    runTimeOut();
    return () => clearTimeout(timerRef.current);
  }, []);

  // setTimeout(() => {
  //   clearInterval(interval);
  // }, 1000);

  // const [gameState, setGameState] = useState("notInitialized");

  const detectLengthMismatch = (e) => {
    console.log(
      "length mismatch",
      "user input length: ",
      e.target.value.length,
      "typing index",
      curentTypingIndex
    );
    const mismmatchFound = e.target.value.length !== curentTypingIndex + 1;
    if (mismmatchFound) {
      console.log("para state: ", paraState.slice(0, 10));
      setMismatch(true);
      console.log(
        "oops mismatchfound-----------------------------------",
        `idx : ${curentTypingIndex}, len : ${e.target.value.length}`
      );

      const typingIndex = e.target.value.length;
      setCurrentTypingIndex(typingIndex);
      console.log("setting index at : ", typingIndex);

      // setParaState(
      //   paraState.map((elem, idx) => {
      //     if (idx <= curentTypingIndex) {
      //       return elem;
      //     } else {
      //       // console.log("at idx :", idx, "setting not initialized in mismatch");
      //       return "notInitialized";
      //     }
      //   })
      // );
      setParaState(
        paraState.map((elem, idx) => {
          // console.log(idx, typingIndex);
          if (idx === typingIndex + 1) {
            console.log("resetting paragraph at  idx: ", idx);
            return "notInitialized";
          } else {
            return elem;
          }
        })
      );
    }
    return mismmatchFound;
  };

  const onParagraphInputChange = (e) => {
    setUserInput(e.target.value);
    console.log("new user state is len is : ", e.target.value.length);
    const misMatchFound = detectLengthMismatch(e);
    console.log("checking if mismatch fuond or not: ", misMatchFound);
    if (!misMatchFound) {
      setParaState(
        paraState.map((elem, idx) => {
          if (idx <= curentTypingIndex) {
            return "completed";
          } else {
            return elem;
          }
        })
      );
      const newParaState = paragraph.map((c, idx) => {
        if (idx === curentTypingIndex) {
          // console.log(
          //   "currentidx ",
          //   idx,
          //   "char compare: ",
          //   c,
          //   "input:",
          //   e.target.value
          // );
          if (paragraph[idx] === e.target.value[e.target.value.length - 1]) {
            console.log(
              "idx:::::::::",
              idx,
              paragraph[idx],
              "current t yping index :",
              curentTypingIndex
            );
            return "completed";
          } else {
            return "wrong";
          }
        } else {
          return paraState[idx];
        }
      });
      console.log("para state: ", newParaState.slice(0, 10));
      setParaState(newParaState);
      setCurrentTypingIndex((p) => p + 1);
    }
  };
  // console.log(paraState.slice(4));

  return (
    <div className="container">
      <div className="warning bg-red-200 p-3 w-1/2 rounded-md mb-4 relative">
        <p className=" absolute right-1 text-xl cursor-pointer top-0">X</p>
        <p className="mr-3">
          Hey there, This project is in very early stage so expect quite a few
          bugs in the application. For example, copying and pasting won't give
          you typing speed of 200WPM and use backspace on your own risk! Have
          fun
        </p>
      </div>
      <div className="preview-box rounded-md bg-purple-100">
        {/* Stats */}
        <div className="flex flex-col items-center mb-12">
          <div className="text-5xl font-bold mb-2">
            {typingSpeed} <span className="text-sm">WPM</span>
          </div>
          <div className>
            (0 <span className="text-sm">CPM)</span>
          </div>
        </div>
        {/* To p shelf */}
        <div className="preview-top-shelf flex flex-row">
          <div className="time-remaining-container flex items-center p-2 bg-green-100">
            <BiTimer className="mr-2 w-1/2" />
            <div>{timeRemaining}</div>
          </div>
          <select className="p-2 rounded-md bg-gray-100">
            <option value>Select Timer</option>
          </select>
          <button className="flex items-center bg-gray-200 p-2 rounded-md">
            <FaRandom className="mr-2" /> Randomize Text
          </button>
        </div>
        <div className="paragraph-text text-lg ">
          {paragraph.map((char, idx) => {
            return paraState[idx] === "notInitialized" ? (
              <>{char}</>
            ) : paraState[idx] === "wrong" ? (
              <span className="bg-red-200">{char}</span>
            ) : (
              <span className="bg-green-200">{char}</span>
            );
          })}
        </div>
        <input
          type="text"
          className="w-full p-2 rounded-md"
          placeholder="start typing here"
          onChange={(e) =>
            gameState === "completed" ? () => {} : onParagraphInputChange(e)
          }
          value={userInput}
        />

        <Button text="Play Again!" classes={"bg-blue-400  "} />
      </div>
    </div>
  );
}

export default App;
